// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4de14cc1","455":"e4b22057","693":"25ac0000","977":"6e88671c"}[chunkId] + ".chunk.js";
};